// extracted by mini-css-extract-plugin
export default {"container":"EndUserAuthLayout_container__6Ih7+"};